import {
    VERIFY_EMAIL_OTP,
    VERIFY_EMAIL_OTP_SUCCESSFUL,
    VERIFY_EMAIL_OTP_FAILED,
    SEND_EMAIL,
    SEND_EMAIL_SUCCESSFUL,
    SEND_EMAIL_FAILED,
    RESET_VERIFY_EMAILOTP_ERRORS,
    UPDATE_NEW_EMAIL,
    UPDATE_NEW_EMAIL_SUCCESS,
    UPDATE_NEW_EMAIL_FAILED,
  } from "./actionTypes"
  
  export const verifyEmailOtp = payload => {
    return {
      type: VERIFY_EMAIL_OTP,
      payload,
    }
  }
  
  export const verifyEmailOtpSuccessful = payload => {
    return {
      type: VERIFY_EMAIL_OTP_SUCCESSFUL,
      payload,
    }
  }
  
  export const verifyEmailOtpFailed = payload => {
    return {
      type: VERIFY_EMAIL_OTP_FAILED,
      payload,
    }
  }
  
  export const sendEmail = email => {
    console.log(email);
    return {
      type: SEND_EMAIL,
      payload: email,
    }
  }
  
  export const sendEmailSuccessful = payload => {
    return {
      type: SEND_EMAIL_SUCCESSFUL,
      payload,
    }
  }
  
  export const sendEmailFailed = payload => {
    return {
      type: SEND_EMAIL_FAILED,
      payload,
    }
  }
  
  export const verifyEmailOtpErrorReset = () => {
    return {
      type: RESET_VERIFY_EMAILOTP_ERRORS,
    }
  }

  export const updateNewEmail = (payload) =>{
    return{
      type: UPDATE_NEW_EMAIL,
      payload
    }
  }

    export const updateNewEmailSuccess = (payload) =>{
    return{
      type: UPDATE_NEW_EMAIL_SUCCESS,
      payload
    }
  }

    export const updateNewEmailFailed = (payload) =>{
    return{
      type: UPDATE_NEW_EMAIL_FAILED,
      payload
    }
  }
  